define('jquery.1508.injectElem',['jquery'],
    function ($) {
        var methods = {
            init: function (options) {

                this.each(function () {
                    var defaults, settings, $this;

                    $this = $(this);

                    settings = $this.data('injectElem');
                    if (typeof (settings) === 'undefined') {

                        defaults = {
                            elem: '<span/>'
                        };

                        settings = $.extend({}, defaults, options);
                        $this.data('injectElem', settings);
                    } else {
                        settings = $.extend({}, settings, options);
                    }
                    $this.wrapInner((settings.elem));
                });
            }
        };
        $.fn.injectElem = function (method) {
            if (methods[method]) {
                return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
            } else if (typeof method === 'object' || !method) {
                return methods.init.apply(this, arguments);
            } else {
                $.error('Method ' + method + ' does not exist in jQuery.injectElem');
            }
        };
    });
